export default "__VITE_PUBLIC_ASSET__58f8deda__"